var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sc-control-header"},[_c('i-switch',{on:{"on-change":_vm.changeHandler},model:{value:(_vm.contract[_vm.type]),callback:function ($$v) {_vm.$set(_vm.contract, _vm.type, $$v)},expression:"contract[type]"}}),_c('span',{staticClass:"ms-help"},[_vm._v("\n    "+_vm._s(_vm.contract[_vm.type] ? "Включено" : "Отключено")+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }